module.exports = __webpack_public_path__ + "static/media/ET262 new.bb8a36d2.jpg";